import { Vector2 } from 'three/webgpu'
import { easing } from 'maath'
import DeviceControl from './DeviceControl'

export default class DeviceDial extends DeviceControl {
	static defaults = {
		axis: 'z',
		sensitivity: 1,
		direction: 1,
		range: null,
		smoothing: 0.05,
		settle: 0.18,
	}

	static draggable = true

	constructor(options = {}) {
		super(options)

		this.value = 0
		this.target = 0
		this.previous = 0
		this.impulse = 0
		this.speed = 0

		this.centre = new Vector2()
	}

	#angle(pointer) {
		this.project(this.centre)

		return Math.atan2(pointer.y - this.centre.y, pointer.x - this.centre.x)
	}

	press(pointer) {
		this.previous = this.#angle(pointer)
	}

	drag(pointer) {
		const { sensitivity, direction, range } = this.options
		const angle = this.#angle(pointer)

		let step = angle - this.previous

		if (step > Math.PI) step -= Math.PI * 2
		if (step < -Math.PI) step += Math.PI * 2

		this.previous = angle
		this.impulse += Math.abs(step)
		this.target += step * sensitivity * direction

		if (range) this.target = Math.min(range[1], Math.max(range[0], this.target))
	}

	update(delta) {
		easing.damp(this, 'speed', this.impulse / Math.max(delta, 0.001), this.options.settle, delta)
		easing.damp(this, 'value', this.target, this.options.smoothing, delta)

		this.impulse = 0

		this.rotation.copy(this.base)
		this.rotation[this.options.axis] += this.value
	}
}
